<template>
  <!-- <div class="publish"> -->
  <div class="faceModal">
    <div class="mask" v-if="isAll" @click="handleClose">
      <div class="modal-all" @click.stop v-if="showFace">
        <div v-if="!isFace" class="exam-detail-moadl" style="width: 480px">
          <div v-if="!showRule">
            <div>
              <el-row class="exam-name">{{ detail.examName }}</el-row>
              <el-row class="row">
                考试时间：
                {{
                  moment(detail.beginTimeFormat, "YYYY-MM-DD HH:mm").format(
                    "YYYY-MM-DD HH:mm"
                  )
                }}
                至
                {{
                  moment(detail.endTimeFormat, "YYYY-MM-DD HH:mm").format(
                    "YYYY-MM-DD HH:mm"
                  )
                }}
              </el-row>
              <div class="exam-detail">
                <div class="left">
                  <el-row class="row">
                    考试时长：
                    {{
                      detail.examTime ? `${detail.examTime / 60}分钟` : "不限"
                    }}</el-row
                  >
                  <el-row class="row">
                    答题方式：
                    {{
                      detail.examDoModeCode == "paper" ? `整卷模式` : "逐题模式"
                    }}</el-row
                  >
                  <el-row class="row">
                    参加次数：<span style="color: #009dff"
                      >{{ detail.attendTimes }} </span
                    >/
                    {{ detail.maxExamNum ? detail.maxExamNum : "无限" }}</el-row
                  >
                </div>
                <img
                  class="right"
                  src="../../assets/exam/notification.png"
                  alt=""
                />
              </div>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 16px;
              "
            >
              <div
                class="face-modal-all"
                v-if="detail.isOpenFaceAuthentication"
              >
                <div class="face-modal-top" style="display: flex">
                  <div>
                    <div class="title">本场考试需要进行人脸识别验证</div>
                    <div class="text">1. 请确认由本人亲自操作；</div>
                    <div class="text">2. 请将脸部置于提示框内；</div>
                    <div class="text">3. 正对摄像头；保持光线充足</div>
                  </div>
                  <div>
                    <img
                      v-if="userInfo.extraProperties.Sex == 'female'"
                      src="../../assets/home/face-recognition-famale.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/home/face-recognition.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="tips" v-if="detail.isExamBeforeNotice">
                  <img
                    style="margin-right: 20px"
                    src="../../assets/home/bugle.png"
                    alt=""
                  />
                  <el-checkbox v-model="isCheck"></el-checkbox>
                  <span @click="toRule" class="rule-tips">
                    我已详细阅读考前须知细则
                  </span>
                </div>
                <div
                  :style="detail.isExamBeforeNotice ? '' : 'margin-top:48px'"
                >
                  <el-button
                    style="
                      width: 174px;
                      background-color: #dcdcdc;
                      border: none;
                      height: 46px;
                      border-radius: 25px;
                    "
                    type="info"
                    @click.stop="handleClose"
                    >取消</el-button
                  >
                  <el-button
                    style="width: 174px; height: 46px; border-radius: 25px"
                    type="primary"
                    v-if="isCheckFace"
                    @click.stop="openFaceRecognition"
                    >开始认证</el-button
                  >
                  <el-button
                    style="
                      width: 174px;
                      height: 46px;
                      border-radius: 25px;
                      background-color: #dcdcdc;
                      border: none;
                    "
                    type="info"
                    v-else
                    @click.stop="noCheckFaceOpenFaceRecognition"
                    >开始认证</el-button
                  >
                </div>
              </div>
              <div v-else style="width: 100%">
                <div class="tips" v-if="detail.isExamBeforeNotice">
                  <img
                    style="margin-right: 25px"
                    src="../../assets/home/bugle.png"
                    alt=""
                  />
                  <el-checkbox v-model="isCheck"></el-checkbox>
                  <span @click="toRule" class="rule-tips">
                    我已详细阅读考前须知细则
                  </span>
                </div>
                <div style="display: flex; justify-content: center">
                  <el-button
                    style="width: 174px; height: 46px; border-radius: 25px"
                    type="primary"
                    @click.stop="checkRule"
                    >开始考试</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-else class="exam-rule">
            <div class="rule-title">
              <div class="rule-button" @click="back">{{ "<" }}</div>
              <span> 考试须知 </span>
            </div>
            <div
              v-if="detail.examBeforeNotice"
              v-html="detail.examBeforeNotice"
              style="line-height: 24px; text-align: justify"
            ></div>
            <ul v-else>
              <li class="rule-text">一. 考前准备</li>
              <li class="rule-text">
                (1)
                考生需掌握每场考试的时间及流程，仔细阅读考试须知、注意事项（如有），自觉参加监考员组织的模拟演练，熟悉考试操作流程，提前准备好考试设备，寻找网络信号好的区域进行调试，以确保能正常参加线上考试；
              </li>
              <li class="rule-text">
                (2)
                考生应于开考前登录SmartExam考试平台核对个人信息，确保无误，如遇个人信息有误或忘记密码请提前联系监考老师，考试期间禁止对任何个人信息做修改操作；
              </li>
              <li class="rule-text">
                (3)
                考生如使用电脑考试，请提前安装谷歌浏览器/QQ浏览器/360安全浏览器。台式电脑还需配置摄像头及安装驱动，确保摄像功能可正常开启。
              </li>
              <li class="rule-text">二. 考试要求</li>
              <li class="rule-text">
                (1)
                考试场所应满足灯光明亮，安静，不逆光、网络信号良好且稳定、桌面干净无杂物等条件；
              </li>
              <li class="rule-text">
                (2)
                请考生自觉遵守考试要求，严禁任何作弊行为。SmartExam考试平台已开启防作弊功能，一旦发现异常行为且经确认，将按作弊处理，该场考试成绩无效；
              </li>
              <li class="rule-text">
                (3)
                考试期间，严禁接打电话、查看除试卷之外的任何页面（包括其他文档、网页等）、离开考试座位等行为；
              </li>
              <li class="rule-text">
                (4) 不得通过截屏、拍照等方式泄露考题内容，否则将追究相应责任。
              </li>
            </ul>
          </div>
        </div>
        <div
          v-show="isFace"
          style="
            width: 480px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          "
        >
          <div>
            <div
              style="
                text-align: center;
                margin-bottom: 16px;
                font-size: 24px;
                font-weight: 700;
                color: #333333;
              "
            >
              人脸识别验证
            </div>
            <div>
              <video style="margin: 0 auto" ref="video" v-if="isVideo"></video>
              <img v-else :src="imgSrc" alt="" />
              <canvas
                style="display: none"
                width="400"
                height="230"
                id="canvasCamera"
              ></canvas>
            </div>
          </div>
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: center;
              margin-top: 16px;
            "
          >
            <el-tag v-if="!isDiscern && iSCamera">正在识别...</el-tag>
            <el-button
              v-if="!isOk && isDiscern"
              type="primary"
              @click.stop="OpenCamera"
              >重新识别</el-button
            >
            <el-button
              v-if="isOk"
              type="primary"
              @click.stop="goExamDetail(detail)"
              >即将进入考试({{ countTime }})</el-button
            >
          </div>
        </div>
        <div class="modal-center">
          <div class="line-center"></div>
        </div>
        <div class="wx-modal">
          <div class="count-down-modal" v-if="cutdownTime != Infinity">
            <div class="title">开考倒计时</div>
            <van-count-down
              ref="countDown"
              :time="cutdownTime"
              @change="getTime"
              :auto-start="true"
              format="DD 天 HH 时 mm 分 ss 秒"
            >
              <template #default="timeData">
                <span class="block block-hour">{{
                  timeData.hours < 10 ? "0" + timeData.hours : timeData.hours
                }}</span>
                <span class="block-symbol">:</span>
                <span class="block block-min">{{
                  timeData.minutes < 10
                    ? "0" + timeData.minutes
                    : timeData.minutes
                }}</span>
                <span class="block-symbol">:</span>
                <span class="block block-sec">{{
                  timeData.seconds < 10
                    ? "0" + timeData.seconds
                    : timeData.seconds
                }}</span>
              </template>
            </van-count-down>
          </div>

          <div class="wx-content">
            <div class="title">微信扫描下方二维码</div>
            <div class="title">按提示完成辅助机位架设</div>
            <div class="qrcode" ref="qrCodeUrl"></div>
            <div class="status success" v-if="isCheckFace">
              辅助机位开启成功
            </div>
            <div class="status error" v-else>尚未开启辅助机位</div>
            <!-- <div class="reset-status" @click="sendMessage">刷新状态</div> -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-else
      width="480px"
      :visible.sync="showFace"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div v-if="!isFace">
        <div v-if="!showRule">
          <div>
            <el-row class="exam-name">{{ detail.examName }}</el-row>
            <el-row class="row">
              考试时间：
              {{
                moment(detail.beginTimeFormat, "YYYY-MM-DD HH:mm").format(
                  "YYYY-MM-DD HH:mm"
                )
              }}
              至
              {{
                moment(detail.endTimeFormat, "YYYY-MM-DD HH:mm").format(
                  "YYYY-MM-DD HH:mm"
                )
              }}
            </el-row>
            <el-row class="row">
              考试时长：
              {{
                detail.examTime ? `${detail.examTime / 60}分钟` : "不限"
              }}</el-row
            >
            <el-row class="row">
              答题方式：
              {{
                detail.examDoModeCode == "paper" ? `整卷模式` : "逐题模式"
              }}</el-row
            >
            <el-row class="row">
              参加次数：<span style="color: #009dff"
                >{{ detail.attendTimes }} </span
              >/ {{ detail.maxExamNum ? detail.maxExamNum : "无限" }}</el-row
            >
          </div>
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: center;
              margin-top: 16px;
            "
          >
            <div class="face-modal" v-if="detail.isOpenFaceAuthentication">
              <div class="face-modal-top" style="display: flex">
                <div>
                  <div class="title">本场考试需要进行人脸识别验证</div>
                  <div class="text">1. 请确认由本人亲自操作；</div>
                  <div class="text">2. 请将脸部置于提示框内；</div>
                  <div class="text">3. 正对摄像头；保持光线充足</div>
                </div>
                <div>
                  <img
                    v-if="userInfo.extraProperties.Sex == 'female'"
                    src="../../assets/home/face-recognition-famale.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/home/face-recognition.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="tips" v-if="detail.isExamBeforeNotice">
                >
                <img
                  style="margin-right: 20px"
                  src="../../assets/home/bugle.png"
                  alt=""
                />
                <el-checkbox v-model="isCheck"></el-checkbox>
                <span @click="toRule" class="rule-tips">
                  我已详细阅读考前须知细则
                </span>
              </div>
              <div>
                <el-button
                  style="
                    width: 174px;
                    background-color: #dcdcdc;
                    border: none;
                    height: 46px;
                    border-radius: 25px;
                  "
                  type="info"
                  @click.stop="handleClose"
                  >取消</el-button
                >
                <el-button
                  style="width: 174px; height: 46px; border-radius: 25px"
                  type="primary"
                  @click.stop="openFaceRecognition"
                  >开始认证</el-button
                >
              </div>
            </div>
            <div v-else style="width: 100%">
              <div class="tips" v-if="detail.isExamBeforeNotice">
                >
                <img
                  style="margin-right: 25px"
                  src="../../assets/home/bugle.png"
                  alt=""
                />
                <el-checkbox v-model="isCheck"></el-checkbox>
                <span @click="toRule" class="rule-tips">
                  我已详细阅读考前须知细则
                </span>
              </div>
              <div style="display: flex; justify-content: center">
                <el-button
                  style="width: 174px; height: 46px; border-radius: 25px"
                  type="primary"
                  @click.stop="checkRule"
                  >开始考试</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div v-else class="exam-rule">
          <div class="rule-title">
            <div class="rule-button" @click="back">{{ "<" }}</div>
            <span> 考试须知 </span>
          </div>
          <div
            v-if="detail.examBeforeNotice"
            v-html="detail.examBeforeNotice"
            style="line-height: 24px; text-align: justify"
          ></div>
          <ul v-else>
            <li class="rule-text">一. 考前准备</li>
            <li class="rule-text">
              (1)
              考生需掌握每场考试的时间及流程，仔细阅读考试须知、注意事项（如有），自觉参加监考员组织的模拟演练，熟悉考试操作流程，提前准备好考试设备，寻找网络信号好的区域进行调试，以确保能正常参加线上考试；
            </li>
            <li class="rule-text">
              (2)
              考生应于开考前登录SmartExam考试平台核对个人信息，确保无误，如遇个人信息有误或忘记密码请提前联系监考老师，考试期间禁止对任何个人信息做修改操作；
            </li>
            <li class="rule-text">
              (3)
              考生如使用电脑考试，请提前安装谷歌浏览器/QQ浏览器/360安全浏览器。台式电脑还需配置摄像头及安装驱动，确保摄像功能可正常开启。
            </li>
            <li class="rule-text">二. 考试要求</li>
            <li class="rule-text">
              (1)
              考试场所应满足灯光明亮，安静，不逆光、网络信号良好且稳定、桌面干净无杂物等条件；
            </li>
            <li class="rule-text">
              (2)
              请考生自觉遵守考试要求，严禁任何作弊行为。SmartExam考试平台已开启防作弊功能，一旦发现异常行为且经确认，将按作弊处理，该场考试成绩无效；
            </li>
            <li class="rule-text">
              (3)
              考试期间，严禁接打电话、查看除试卷之外的任何页面（包括其他文档、网页等）、离开考试座位等行为；
            </li>
            <li class="rule-text">
              (4) 不得通过截屏、拍照等方式泄露考题内容，否则将追究相应责任。
            </li>
          </ul>
        </div>
      </div>
      <div v-show="isFace">
        <div style="display: flex; align-items: center; flex-direction: column">
          <div
            style="
              text-align: center;
              margin-bottom: 16px;
              font-size: 24px;
              font-weight: 700;
              color: #333333;
            "
          >
            人脸识别验证
          </div>
          <div>
            <video style="margin: 0 auto" ref="video" v-if="isVideo"></video>
            <img v-else :src="imgSrc" alt="" />
            <canvas
              style="display: none"
              width="400"
              height="230"
              id="canvasCamera"
            ></canvas>
          </div>
        </div>
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 16px;
          "
        >
          <el-tag v-if="!isDiscern && iSCamera">正在识别...</el-tag>
          <el-button
            v-if="!isOk && isDiscern"
            type="primary"
            @click.stop="OpenCamera"
            >重新识别</el-button
          >
          <el-button
            v-if="isOk"
            type="primary"
            @click.stop="goExamDetail(detail)"
            >即将进入考试({{ countTime }})</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/api/examList";
import moment from "moment";
import QRCode from "../../plugin/qrcode.js";
import userApi from "@/api/home";

export default {
  props: {
    showFace: {
      required: true,
      type: Boolean,
      default: false,
    },
    isAll: {
      required: true,
      type: Boolean,
      default: false,
    },
    goExam: {
      required: true,
      type: Function,
      default: false,
    },
    detail: {
      require: true,
      type: Object,
      default: {
        examName: "",
        beginTimeFormat: "",
        endTimeFormat: "",
        examTime: "",
        maxExamNum: "",
        openCameraInvigilateInterval: 0.5,
        IsOpenFaceAuthentication: false,
        attendTimes: 0,
      },
    },
  },
  data() {
    return {
      cutdownTime: Infinity, //距离开考倒计时时长
      isCheckFace: false,
      countTime: 3,
      iSCamera: true,
      isVideo: true,
      isFace: false,
      isOk: false,
      isCheck: false,
      mediaStreamTrack: {},
      video_stream: "", // 视频stream
      imgSrc: "", // 拍照图片
      canvas: null,
      context: null,
      isDiscern: false,
      showRule: false,
      countDownTime: null,
      goExamTime: null,
      Link: "",
      examDetail: {},
      userInfo: {
        extraProperties: {},
      },
    };
  },
  created() {
    console.warn("this.detail", this.detail);
    console.warn("this.isAll", this.isAll);
    if (this.detail.isExamBeforeNotice == false) {
      this.isCheck = true;
    }
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    }
    if (this.detail.isOpenFaceAuthentication) {
      this.getLink();
    }
    (this.isOk = false), (this.isDiscern = false), (this.isFace = false);
  },
  mounted() {
    this.computerTime();
    if (this.isAll) {
      this.sendMessage();
      let _this = this;
      this.signalr.on("receiveWebRtcMessage", function (res) {
        console.log(res);
        if (res) {
          _this.isCheckFace = true;
          _this.$forceUpdate();
        }
      });
      this.signalr.on("receiveOfflineRtcMessage", function (OfflineRes) {
        console.log("receiveOfflineRtcMessage", OfflineRes);
        _this.isCheckFace = false;
        _this.$forceUpdate();
      });
    }
  },
  destroyed() {
    // this.isAll = false;
    (this.isOk = false), (this.isDiscern = false), (this.isFace = false);
    this.CloseCamera();
  },
  methods: {
    moment,
    getTime(item) {
      // console.warn(item);
    },
    computerTime() {
      console.warn(
        "this.detail.beginTime",
        this.moment(this.detail.beginTime).valueOf()
      );
      console.warn("current time", this.moment().valueOf());
      let timeDifference =
        this.moment(this.detail.beginTime).valueOf() - this.moment().valueOf();
      console.warn("timeDifference", timeDifference);
      if (timeDifference > 0) {
        let t1 = moment(this.detail.beginTime);
        let t2 = moment();
        console.warn("t1", t1);
        console.warn("t2", t2);
        let dura = t2.format("x") - t1.format("x");
        let tempTime = moment.duration(dura);
        tempTime.days(); //是（实际天数%30），例如相差36天，计算成6。以下类推
        tempTime.hours();
        tempTime.minutes();
        console.warn("dura", dura);

        console.warn("tempTime.minutes();", tempTime.minutes());
        //计算时间差并转换成指定的时间单位
        console.log(t2.diff(t1, "day")); //实际相差多少天，就计算成多少天，以下类推
        console.log(t2.diff(t1, "minute"));
        console.log("hour", t2.diff(t1, "hour"));
        console.log("second", t2.diff(t1, "second"));
        if (t2.diff(t1, "hour") < 100) {
          this.cutdownTime = t2.diff(t1, "second") * -1000;
        }
      }
    },
    sendMessage() {
      this.signalr
        .invoke(
          "SendMessage",
          this.userInfo.id,
          "发送消息至移动端",
          "receivePhoneRtcMessage"
        )
        .catch(function (err) {
          return console.error(err.toString());
        });
    },
    getLink() {
      userApi
        .getCopyright()
        .then((res) => {
          res.data.forEach((item) => {
            if (item.name == "Abp.Identity.User.WebAppUrl") {
              this.Link = item.value;
              this.getIsAllDetail();
            }
          });
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    creatQrCode(params) {
      sessionStorage.setItem("Link", this.Link);
      let qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: `${this.Link}/#/rtcHome?Uid=${params.examUid}&Aid=${params.examArrangeUid}&Key=${params.secretKey}&Name=${params.userName}&Gid=${params.examGradeUid}`, // 需要转换为二维码的内容
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    getIsAllDetail() {
      // console.warn(this.detail);
      Api.getIsAllDetail(this.detail.examUid, this.detail.examArrangeUid)
        .then((res) => {
          let params = {
            examUid: res.data.examUid,
            examArrangeUid: res.data.examArrangeUid,
            secretKey: res.data.secretKey,
            examGradeUid: res.data.examGradeUid,
            userName: res.data.userName,
          };
          this.examDetail = res.data;
          if (this.isAll) {
            sessionStorage.setItem(
              "faceDetail",
              JSON.stringify(this.examDetail)
            );
            this.creatQrCode(params);
          }
          console.warn("getIsAllDetail", res);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    goExamDetail(detail) {
      this.countTime = 0;
      clearInterval(this.countDownTime);
      clearTimeout(this.goExamTime);
      let params = detail;
      params.examGradeUid = this.examDetail.examGradeUid;
      this.CloseCamera();
      this.goExam(params);
    },
    toRule() {
      this.showRule = true;
      this.$forceUpdate();
    },
    back() {
      this.showRule = false;
      this.isCheck = true;
      this.$forceUpdate();
    },
    checkRule() {
      if (this.isCheck) {
        this.goExam(this.detail);
      } else {
        this.$message.error("请阅读并同意考前须知");
      }
    },
    openFaceRecognition() {
      if (this.isCheck) {
        this.isFace = true;
        this.OpenCamera();
      } else {
        this.$message.error("请阅读并同意考前须知");
      }
    },
    noCheckFaceOpenFaceRecognition() {
      if (this.isCheckFace) {
        if (this.isCheck) {
          this.isFace = true;
          this.OpenCamera();
        } else {
          this.$message.error("请阅读并同意考前须知");
        }
      } else {
        this.$message.error("请连接辅机位后开始认证");
      }
    },
    handleClose() {
      this.$emit("closepop"); //通知父组件改变。
      this.CloseCamera();
    },
    // 调用打开摄像头功能
    getCamera() {
      // 获取 canvas 画布

      this.canvas = document.getElementById("canvasCamera");
      this.context = this.canvas.getContext("2d");
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 正常支持版本
      console.warn(navigator.mediaDevices.getUserMedia);
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: true,
          })
          .then((stream) => {
            // 摄像头开启成功
            console.warn("摄像头开启成功");
            this.mediaStreamTrack =
              typeof stream.stop === "function"
                ? stream
                : stream.getTracks()[0];
            this.video_stream = stream;
            this.$refs.video.srcObject = stream;
            this.$refs.video.play();

            let take = setTimeout(() => {
              this.setImage();
              clearTimeout(take);
            }, 3000);
          })
          .catch((err) => {
            console.log(err);
            this.isDiscern = true;
            this.iSCamera = false;

            // this.$message.error('摄像头开启失败，请检查摄像头是否可用！');
            this.$message({
              type: "error",
              // dangerouslyUseHTMLString: true,
              duration: 5000,
              message: `摄像头开启失败，请检查摄像头是否可用！`,
            });
          });
      } else {
        console.warn("摄像头开启失败，请检查摄像头是否可用！");
        this.isDiscern = true;
        this.iSCamera = false;
        this.$message({
          type: "error",
          // dangerouslyUseHTMLString: true,
          duration: 5000,
          message: `摄像头开启失败，请检查摄像头是否可用！`,
        });
      }
    },
    // 拍照 绘制图片
    setImage() {
      console.log("拍照");
      this.isVideo = true;

      // 点击canvas画图
      // 获取图片base64链接
      this.context.drawImage(this.$refs.video, 0, 0, 400, 230);
      let image = this.canvas.toDataURL("image/png");
      this.imgSrc = image;
      if (this.imgSrc) {
        this.checkFace(this.imgSrc);
      } else {
        let haveImg = setInterval(() => {
          if (this.imgSrc) {
            this.checkFace(this.imgSrc);
            clearInterval(haveImg);
          }
        }, 300000);
      }
    },

    checkFace(imgSrc) {
      let params = {};
      params.image = imgSrc;
      params.batchId = this.detail.examArrangeUid;
      params.relationId = this.examDetail.examGradeUid;
      params.sourceType = "exam";
      params.callConfigList = [0, 3];
      Api.verifyFaceAll(params)
        .then((res) => {
          if (res.data.status === 1) {
            if (res.data.businessData.isSuccess) {
              this.isDiscern = true;
              this.isOk = true;
              this.detail.verificationKey =
                res.data.businessData.verificationKey;
              console.warn(this.detail);
              this.$message.success("识别通过,即将考试");
              this.countDownTime = setInterval(() => {
                this.countTime--;
              }, 1000);
              this.goExamTime = setTimeout(() => {
                this.CloseCamera();
                let params = this.detail;
                params.examGradeUid = this.examDetail.examGradeUid;
                this.goExam(params);
                clearTimeout(time);
                clearInterval(this.countDownTime);
              }, 3000);
              // this.$message.success('识别通过,请点击开始考试');
            } else {
              this.isDiscern = true;
              this.isVideo = false;
              this.CloseCamera();
              let _this = this;
              this.$confirm("识别失败,是否重新识别?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  _this.isDiscern = true;
                  _this.OpenCamera();
                })
                .catch(() => {});
              this.$message.error("识别错误,请重新识别");
            }
          } else {
            this.isDiscern = true;

            this.$message.error(res.data.errorMessage);
          }
          console.warn(res);
        })
        .catch((err) => {
          this.CloseCamera();
          this.isDiscern = true;
          this.isVideo = false;
          console.warn(err);
        });
    },
    // 打开摄像头
    OpenCamera() {
      console.log("打开摄像头");
      this.isVideo = true;
      this.isDiscern = false;
      this.getCamera();
    },
    // 关闭摄像头
    CloseCamera() {
      if (this.detail.isOpenFaceAuthentication && this.isFace) {
        this.MediaStreamTrack && this.MediaStreamTrack.stop();
        this.$refs.video.srcObject.getTracks()[0].stop();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 18px;
}
.mask {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  // display: none;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  .modal-all {
    position: absolute;
    background-color: #fff;
    overflow: hidden;
    // width: 730px;
    min-height: 590px;
    border-radius: 18px;
    top: 50%;
    left: 50%;
    margin-top: -314px;
    margin-left: -365px;
    display: flex;
    .exam-detail-moadl {
      width: 456px;
      padding: 30px 45px;
      .exam-detail {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
        .right {
          width: 85px;
          height: 89px;
        }
      }
    }
    .modal-center {
      min-height: 590px;
      max-height: 100%;
      width: 50px;
      display: flex;
      justify-content: center;
      position: relative;
      padding: 20px 0;
      &::after {
        content: "";
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #73797d;
        position: absolute;
        top: -15px;
      }
      &::before {
        content: "";
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #7d7d7d;
        position: absolute;
        bottom: -15px;
      }
      .line-center {
        width: 1px;
        height: 100%;
        border-left: 1px dashed #dcdcdc;
      }
    }
    .wx-modal {
      width: 224px;
      padding: 30px 25px;
      display: flex;
      align-items: center;
      position: relative;
      .count-down-modal {
        position: absolute;
        top: 30px;
        .title {
          margin-bottom: 30px;
          font-size: 24px;
          font-weight: 700;
          text-align: center;
          color: #333333;
        }
        .van-count-down {
          display: flex;
          justify-content: center;
        }
      }

      .block {
        font-size: 24px;
        font-weight: 500;
        text-align: left;
        height: 40px;
        border-radius: 3px;
        // color: #1fa3ff;
        color: #fff;
        background-color: #1fa3ff;
        line-height: 42px;
        padding: 5px;
        display: flex;
        align-items: center;
        position: relative;
        &.block-hour {
          &::before {
            content: "时";
            position: absolute;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            color: #c8c8c8;
            line-height: 32px;
            bottom: -30px;
            width: 100%;
            left: 0;
          }
        }
        &.block-min {
          &::before {
            content: "分";
            position: absolute;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            color: #c8c8c8;
            line-height: 32px;
            bottom: -30px;
            width: 100%;
            left: 0;
          }
        }
        &.block-sec {
          &::before {
            content: "秒";
            position: absolute;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            color: #c8c8c8;
            line-height: 32px;
            bottom: -30px;
            width: 100%;
            left: 0;
          }
        }
      }
      .block-symbol {
        margin: 0 5px;
        font-size: 30px;
        font-weight: 500;
        text-align: left;
        color: #1fa3ff;
        line-height: 42px;
      }
      .wx-content {
        height: 242px;
        .title {
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          color: #1fa3ff;
          line-height: 24px;
        }
        .qrcode {
          display: flex;
          justify-content: center;
          margin: 20px 0;
        }
        .status {
          font-size: 16px;
          font-weight: 400;
          text-align: end;
          line-height: 32px;
          position: relative;
          &::before {
            content: "";
            width: 16px;
            height: 16px;
            border-radius: 50%;
            position: absolute;
            top: 8px;
            left: 0;
          }
        }
        .success {
          color: #44d7b6;
          &::before {
            background: rgba(68, 215, 182, 0.7);
          }
        }
        .error {
          color: #fa6a67;
          &::before {
            background: rgba(250, 106, 103, 0.7);
          }
        }
        .reset-status {
          font-size: 16px;
          font-weight: 400;
          text-align: center;
          color: #999999;
          line-height: 32px;
        }
        // margin: 0 auto;
      }
    }
    .row {
      padding-left: 0 !important;
    }
  }
}

.tips {
  font-size: 14px;
  // height: 90px;
  font-weight: 300;
  text-align: center;
  color: #1fa3ff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
  position: relative;
  .rule-tips {
    margin-left: 8px;
  }
}
.face-modal-all {
  width: 480px;
  border-top: 1px solid #e6e6e6;
  // padding-left: 30px;
  padding-top: 28px;
  .face-modal-top {
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #1fa3ff;
    }
    .text {
      font-size: 16px;
      margin-top: 8px;
      font-weight: 400;
      text-align: left;
      color: #999999;
    }
  }
}
.face-modal {
  width: 480px;
  border-top: 1px solid #e6e6e6;
  padding-left: 30px;
  padding-top: 28px;
  .face-modal-top {
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #1fa3ff;
    }
    .text {
      font-size: 16px;
      margin-top: 8px;
      font-weight: 400;
      text-align: left;
      color: #999999;
    }
  }
}
.exam-rule {
  .rule-title {
    width: 100%;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    color: #333333;
    position: relative;
    margin-bottom: 30px;
    .rule-button {
      width: 29px;
      height: 29px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
      border-radius: 2px;
      color: #a1a1a1;
      position: absolute;
    }
  }
  .rule-text {
    font-size: 14px;
    font-weight: 400;
    text-align: justify;
    color: #999999;
    line-height: 24px;
  }
  padding: 0 30px;
}
video {
  width: 400px;
  height: 230px;
}
canvas {
  // width: 100%;
  // height: 300px;
  width: 400px;
  height: 230px;
}
.customClass {
  width: 510px;
}
.exam-name {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: #333333;
  margin-bottom: 22px;
}
.row {
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  padding-left: 30px;
  color: #999999;
  // line-height: 32px;
}
</style>